import React from 'react'
// views
import { Caption, LastUpdatedVariant, Value, Wrapper } from './views'

export { LastUpdatedVariant } from './views'

interface Props {
  // The relative time, e.g. "3 minutes ago"
  value: string
  variant: LastUpdatedVariant
  'data-testid'?: string
}

const LastUpdated: React.FC<Props> = ({ value, variant, 'data-testid': dataTestId }) => (
  <Wrapper data-testid={dataTestId}>
    {/* The trailing space joins the lines for a screen reader; at the end of a line it is not drawn */}
    <Caption variant={variant}>Last updated </Caption>
    <Value variant={variant}>{value}</Value>
  </Wrapper>
)

export default LastUpdated
